/**
 * 单位转换辅助函数
 */

// 英寸转厘米
export const in2cm = (n: number): number => n * 2.54;

// 磅转千克
export const lb2kg = (n: number): number => n * 0.453592;

// 盎司转千克
export const oz2kg = (n: number): number => n * 0.0283495;
